import React, { Component, RefObject } from "react";

import { observable, action, makeObservable } from "mobx";
import { inject, observer } from "mobx-react";

import styled from "styled-components/macro";
import {  } from "@blueprintjs/core";
import { Line } from "react-chartjs-2";

import { withTranslation } from "react-i18next";
import i18n from "../../../utils/i18n/i18n";

import { AppStore } from "../../../stores/AppStore";


const Wrapper = styled.div``;
const Note = styled.div`
  margin-bottom: 1rem;
  line-height: 30px;
`;


interface ProgressCheckitemTabProps {}

interface InjectedProps extends ProgressCheckitemTabProps {
  appStore: AppStore;
}

@inject("appStore")
@observer
class ProgressCheckitemTab extends Component<ProgressCheckitemTabProps> {
  private chartRef:RefObject<Line>;
  private labels:Array<string> = [];
  private datasets:Array<any> = [];

  @observable readyToShow: boolean = false;
  @action setReadyToShow(value: boolean) { this.readyToShow = value; }

  @observable yMax = 0;
  @action setYMax(value: number) { this.yMax = value; }
  private yAcc: number = 0;
  private ySuggest: number = 0;

  constructor(props: ProgressCheckitemTabProps) {
    super(props);
    this.chartRef = React.createRef();
    makeObservable(this);
  }

  componentDidMount() {
    const data = JSON.parse(this.trelloStore.progressCheckitemData);

    this.labels = data.labels.slice();
    this.datasets = data.datasets.slice();

    this.setReadyToShow(true);
  }

  get injected() { return this.props as InjectedProps; }
  get userStore() { return this.injected.appStore.userStore; }
  get trelloStore() { return this.injected.appStore.trelloStore; }

  handleWheel = (e: any) => {
    this.yAcc += e.deltaY;
    if(this.yAcc >= 50) {
      this.setYMax(this.yMax+5);
      this.yAcc = 0;
    }
    if(this.yAcc <= -50) {
      if(this.yMax > this.ySuggest) {
        this.setYMax(this.yMax-5);
      }
      this.yAcc = 0;
    }
  }

  // 휠 이벤트가 다른 영역 스크롤을 일으키지 않도록 조정
  passivePreventDefault = (e: any) => {
    if (e.preventDefault) { e.preventDefault(); }
  }
  handleMouseEnter = (e: any) => {
    window.addEventListener('wheel', this.passivePreventDefault, {passive: false});
  }
  handleMouseLeave = (e: any) => {
    window.removeEventListener('wheel', this.passivePreventDefault);
  }  

  render() {
    return (
      <Wrapper
        onWheel={this.handleWheel}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}            
      >
        <Note>
          {i18n.t("progress-checkitem-desc")}
        </Note>
        {this.readyToShow && (
          <>
            <Line 
              ref={this.chartRef}
              data={{
                labels: this.labels ? this.labels : [],
                datasets: this.datasets ? this.datasets : []
              }}
              options={{
                scales: { 
                  xAxes: [{
                    type: "time",
                    time: {
                      unit: 'day',
                      unitStepSize: 7,
                      tooltipFormat: "YYYY-MM-DD",
                      displayFormats: {
                        day: 'YYYY-MM-DD'
                      }
                    },
                    gridLines: {
                      color: 'black',
                      borderDash: [20, 2],
                      z: 999,
                    }
                  }],
                  yAxes: [{ 
                    stacked: true,
                    ticks: {
                      suggestedMax: this.yMax,
                      callback: (value: number, index: any, values: any) => {
                        if(this.yMax === 0) {
                          this.ySuggest = value;
                          this.setYMax(value);
                        }
                        return value;
                      },
                    }
                  }] 
                },
                legend: { position: 'left', align: 'start', reverse: true },
              }}
            />
          </>
        )}
      </Wrapper>
    )
  }
}

export default withTranslation()(ProgressCheckitemTab);